import * as React from 'react';
import verifyIcon from 'one-ui-svg/images/verifypatient.png';
import { useCtx } from 'one-ui-provider';

import {
  Props,
} from 'one-ui';

export interface PatientVerifyProps extends Props {
  onClick?: () => void;
}

/**
 *
 * @param props contains the provider count and phone number of caller(ANI).
 */
export const PatientVerify = ({
  onClick
}: PatientVerifyProps) => {
  const { resolver } = useCtx();
  return (
    <div className="new-callprovider">
      <div className="new-callprovider__box">
        <a onClick={onClick}>
          <img src={resolver(verifyIcon)} height="124" width="128" className="new-callprovider__ico" alt="phone ico" draggable="false"/>
        </a>
        <h3 className="new-callprovider__title">Verify Patient</h3>
        <div className="new-callprovider__note">Please complete the Patient verification</div>
        <br />
        <br />
      </div>
    </div>
  )
}
